import React from 'react';

export default function Sqncr3D() {
  return (
    <iframe
      src="/sqncr_3d.html?embedded&v=3"
      title="SQNCR 3D"
      style={{
        width: '100%',
        height: '320px',
        border: 'none',
        display: 'block',
        background: '#050505',
      }}
    />
  );
}
